module.exports = __webpack_public_path__ + "img/06740b5.jpg";